import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component } from "@/decorators";
import BandeiraModel from "@/models/financeiro/bandeiraModel";
import BandeiraService from "@/services/financeiro/bandeiraService";

import ListComponentBase from "../listComponentBase";

@Component
export default class BandeiraListComponent extends ListComponentBase<BandeiraModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("descricao", this.$t("__.ts.descricao"), GridColumnType.String),
            new GridColumn("ativo", this.$t("__.ts.ativo"), GridColumnType.Boolean),
        ];
    }

    private beforeMount() {
        this.setProps(new BandeiraService(), "bandeira", "descricao");
    }
}
